module.exports = __webpack_public_path__ + "img/vinyl-frame.573f3ec0.png";